import React from 'react';
import PresentationVideo from '../components/pure/presentationVideo';

const Intro = () => {
    return (
        <div className='container mx-auto h-screen flex items-center justify-center'>
            <PresentationVideo />
        </div>
    );
}

export default Intro;
